// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Paleta: negro / grises / rojo (#A61B34), alineada con Sidebar y MiniIOT */

.button-alerts-dashboard {
  min-height: 100%;
  padding: 24px 28px 40px;
  color: #ffffff;
  background-color: #0a0a0a;
  box-sizing: border-box;
  color-scheme: dark;
}

.bad-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}

.bad-header-text h1 {
  margin: 0 0 6px;
  font-size: 1.45rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.02em;
}

.bad-sub {
  margin: 0;
  font-size: 0.875rem;
  color: #9ca3af;
  max-width: 52rem;
  line-height: 1.45;
}

.bad-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
}

.bad-filter {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.75rem;
  color: #9ca3af;
}

.bad-filter input {
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #2a2a2a;
  background-color: #1a1a1a;
  color: #ffffff;
  font-size: 0.875rem;
}

.bad-filter input:focus {
  outline: none;
  border-color: #A61B34;
}

/* Calendario nativo alineado al tema oscuro */
.bad-filter input.bad-date-input {
  color-scheme: dark;
  min-height: 38px;
}

.bad-filter input.bad-date-input::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 0.75;
  filter: invert(0.85);
}

.bad-filter input.bad-date-input::-webkit-calendar-picker-indicator:hover {
  opacity: 1;
}

.bad-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 0.15s, border-color 0.15s, opacity 0.15s;
}

.bad-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.bad-btn-primary {
  background-color: #A61B34;
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.08);
}

.bad-btn-primary:hover:not(:disabled) {
  background-color: #8b1530;
}

.bad-btn-ghost {
  background-color: #1a1a1a;
  color: #e5e7eb;
  border-color: #2a2a2a;
}

.bad-btn-ghost:hover:not(:disabled) {
  background-color: #374151;
  color: #ffffff;
  border-color: #4b5563;
}

.bad-btn-sm {
  padding: 6px 10px;
  font-size: 0.8125rem;
}

.bad-spin {
  animation: bad-spin 0.9s linear infinite;
}

@keyframes bad-spin {
  to {
    transform: rotate(360deg);
  }
}

.bad-banner {
  padding: 10px 14px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 0.875rem;
}

.bad-banner-error {
  background: rgba(166, 27, 52, 0.15);
  border: 1px solid rgba(220, 38, 38, 0.45);
  color: #fecaca;
}

.bad-layout {
  display: grid;
  grid-template-columns: minmax(280px, 340px) 1fr;
  gap: 20px;
  align-items: start;
}

@media (max-width: 1100px) {
  .bad-layout {
    grid-template-columns: 1fr;
  }
}

.bad-aside {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.bad-main {
  min-width: 0;
}

.bad-card {
  background-color: #1a1a1a;
  border: 1px solid #2a2a2a;
  border-radius: 10px;
  padding: 16px 18px;
}

.bad-card-fill {
  display: flex;
  flex-direction: column;
  min-height: 420px;
}

.bad-card h2 {
  margin: 0 0 6px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #ffffff;
}

.bad-hint {
  margin: 0 0 12px;
  font-size: 0.75rem;
  color: #9ca3af;
  line-height: 1.4;
}

.bad-card-head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
}

.bad-card-head h2 {
  margin: 0;
}

.bad-meta {
  font-size: 0.8125rem;
  color: #9ca3af;
}

.bad-table-wrap {
  border-radius: 8px;
  border: 1px solid #2a2a2a;
  overflow: hidden;
}

.bad-table-scroll {
  flex: 1 1;
  overflow: auto;
  max-height: min(58vh, 640px);
  scrollbar-width: thin;
  scrollbar-color: #4b5563 #111111;
}

.bad-table-scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.bad-table-scroll::-webkit-scrollbar-track {
  background: #111111;
  border-radius: 4px;
}

.bad-table-scroll::-webkit-scrollbar-thumb {
  background: #4b5563;
  border-radius: 4px;
}

.bad-table-scroll::-webkit-scrollbar-thumb:hover {
  background: #6b7280;
}

.bad-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
}

.bad-table thead {
  background-color: #111111;
  position: sticky;
  top: 0;
  z-index: 1;
}

.bad-table th {
  color: #d1d5db;
  font-weight: 600;
}

.bad-table th,
.bad-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #2a2a2a;
}

.bad-table-dense th,
.bad-table-dense td {
  padding: 8px 10px;
}

.bad-table tbody tr:hover {
  background-color: rgba(55, 65, 81, 0.35);
}

.bad-row-selected {
  background-color: rgba(166, 27, 52, 0.22) !important;
  box-shadow: inset 3px 0 0 #A61B34;
}

.bad-num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.bad-empty {
  text-align: center;
  color: #9ca3af;
  padding: 20px 12px !important;
}

.bad-status-cell {
  vertical-align: middle;
  text-align: center;
}

.bad-table thead th.bad-status-th {
  text-align: center;
}

.bad-table thead th.bad-actions-th {
  text-align: center;
}

.bad-status-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border: 1px solid transparent;
  line-height: 1.2;
  white-space: nowrap;
}

/* Pendiente: resalta en rojo (misma familia que #A61B34) */
.bad-status-chip--pending {
  background: rgba(166, 27, 52, 0.35);
  color: #fecaca;
  border-color: rgba(220, 38, 38, 0.65);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);
}

.bad-status-chip--done {
  background: rgba(22, 163, 74, 0.22);
  color: #86efac;
  border-color: rgba(34, 197, 94, 0.55);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
}

.bad-actions-col {
  width: 1%;
  vertical-align: middle;
  text-align: center;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.bad-action-btns {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  min-width: 7.5rem;
  max-width: 10rem;
  margin: 0 auto;
}

.bad-action-btn {
  width: 100%;
  justify-content: center;
  box-sizing: border-box;
}

.bad-actions-empty {
  display: block;
  color: #6b7280;
  font-size: 0.875rem;
}

.bad-comment-cell {
  max-width: 160px;
  color: #9ca3af;
  font-size: 0.78rem;
  vertical-align: middle;
}

.bad-comment-cell--interactive {
  cursor: pointer;
}

.bad-comment-cell--interactive:hover {
  color: #e5e7eb;
  background-color: rgba(55, 65, 81, 0.25);
}

.bad-comment-empty {
  color: #6b7280;
}

.bad-comment-preview {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

/* Modal solo lectura: mensaje y comentario de gestión completos */
.bad-detail-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10050;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  backdrop-filter: blur(2px);
  box-sizing: border-box;
}

.bad-detail-dialog {
  width: 100%;
  max-width: min(720px, calc(100vw - 32px));
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  background: #1a1a1a;
  border: 1px solid #2a2a2a;
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  font-family: inherit;
  color: #f3f4f6;
}

.bad-detail-header {
  padding: 18px 20px 14px;
  border-bottom: 1px solid #2a2a2a;
  flex-shrink: 0;
}

.bad-detail-title {
  margin: 0 0 8px;
  font-size: 1.1rem;
  font-weight: 700;
  color: #ffffff;
}

.bad-detail-sub {
  margin: 0;
  font-size: 0.8125rem;
  color: #9ca3af;
  line-height: 1.45;
}

.bad-detail-body {
  padding: 16px 20px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.bad-detail-grid {
  display: grid;
  grid-template-columns: 7.5rem 1fr;
  gap: 8px 14px;
  align-items: start;
  margin-bottom: 16px;
}

.bad-detail-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #9ca3af;
}

.bad-detail-label--block {
  display: block;
  margin-bottom: 6px;
}

.bad-detail-value {
  font-size: 0.875rem;
  color: #e5e7eb;
  word-break: break-word;
}

.bad-detail-block {
  margin-bottom: 16px;
}

.bad-detail-block:last-child {
  margin-bottom: 0;
}

.bad-detail-block--comment-first {
  margin-bottom: 20px;
}

.bad-detail-char-count {
  display: block;
  margin: 0 0 8px;
  font-size: 0.7rem;
  color: #6b7280;
  font-variant-numeric: tabular-nums;
}

.bad-detail-pre {
  margin: 0;
  padding: 12px 14px;
  border-radius: 8px;
  background: #0a0a0a;
  border: 1px solid #2a2a2a;
  font-size: 0.8125rem;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: min(200px, 32vh);
  overflow-y: auto;
  color: #d1d5db;
}

/* Comentario de gestión: sin tope de altura; el scroll es el del panel .bad-detail-body (un solo scroll, texto completo). */
.bad-detail-pre--comment {
  max-height: none;
  min-height: 6rem;
  overflow: visible;
  font-size: 0.875rem;
  line-height: 1.55;
  padding: 14px 16px;
  border-color: rgba(34, 197, 94, 0.35);
}

.bad-detail-pending-note {
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: #9ca3af;
}

.bad-detail-footer {
  padding: 14px 20px 18px;
  border-top: 1px solid #2a2a2a;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
}

.bad-pagination {
  display: flex;
  gap: 10px;
  margin-top: 14px;
  padding-top: 4px;
}

/* ─── Export modal ─────────────────────────────────────────── */

.bad-export-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10050;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  backdrop-filter: blur(2px);
  box-sizing: border-box;
}

.bad-export-dialog {
  width: 100%;
  max-width: 420px;
  background: #1a1a1a;
  border: 1px solid #2a2a2a;
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  color: #f3f4f6;
  display: flex;
  flex-direction: column;
}

.bad-export-header {
  padding: 20px 22px 14px;
  border-bottom: 1px solid #2a2a2a;
}

.bad-export-header-icon {
  color: #A61B34;
  margin-bottom: 8px;
}

.bad-export-title {
  margin: 0 0 8px;
  font-size: 1.1rem;
  font-weight: 700;
  color: #ffffff;
}

.bad-export-sub {
  margin: 0;
  font-size: 0.8125rem;
  color: #9ca3af;
  line-height: 1.45;
}

.bad-export-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  padding: 20px 22px;
}

.bad-export-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px 12px;
  border-radius: 10px;
  border: 1px solid #2a2a2a;
  background: #111111;
  color: #e5e7eb;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, transform 0.1s;
}

.bad-export-option:hover:not(:disabled) {
  border-color: #A61B34;
  background: rgba(166, 27, 52, 0.1);
  transform: translateY(-1px);
}

.bad-export-option:active:not(:disabled) {
  transform: translateY(0);
}

.bad-export-option:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.bad-export-option-icon {
  opacity: 0.9;
}

.bad-export-option-icon--pdf {
  color: #ef4444;
}

.bad-export-option-icon--excel {
  color: #22c55e;
}

.bad-export-option-label {
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.bad-export-option-desc {
  font-size: 0.72rem;
  color: #9ca3af;
  text-align: center;
  line-height: 1.35;
}

.bad-export-loading {
  text-align: center;
  font-size: 0.8125rem;
  color: #A61B34;
  padding: 0 22px 8px;
  animation: bad-pulse 1.2s ease-in-out infinite;
}

@keyframes bad-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.bad-export-footer {
  padding: 14px 22px 18px;
  border-top: 1px solid #2a2a2a;
  display: flex;
  justify-content: flex-end;
}

/* Bloque de reproducción de audio (perifoneo / alerta personalizada) en el modal de detalle */
.bad-detail-audio-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.bad-detail-audio-hint {
  color: #9ca3af;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ButtonAlertsDashboardPage.css"],"names":[],"mappings":"AAAA,4EAA4E;;AAE5E;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oDAAoD;EACpD,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4HAA4H;AAC5H;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iEAAiE;;AAEjE;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gEAAgE;AAClE;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA,8FAA8F;AAC9F;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":["/* Paleta: negro / grises / rojo (#A61B34), alineada con Sidebar y MiniIOT */\n\n.button-alerts-dashboard {\n  min-height: 100%;\n  padding: 24px 28px 40px;\n  color: #ffffff;\n  background-color: #0a0a0a;\n  box-sizing: border-box;\n  color-scheme: dark;\n}\n\n.bad-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.bad-header-text h1 {\n  margin: 0 0 6px;\n  font-size: 1.45rem;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: -0.02em;\n}\n\n.bad-sub {\n  margin: 0;\n  font-size: 0.875rem;\n  color: #9ca3af;\n  max-width: 52rem;\n  line-height: 1.45;\n}\n\n.bad-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 12px;\n}\n\n.bad-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 0.75rem;\n  color: #9ca3af;\n}\n\n.bad-filter input {\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid #2a2a2a;\n  background-color: #1a1a1a;\n  color: #ffffff;\n  font-size: 0.875rem;\n}\n\n.bad-filter input:focus {\n  outline: none;\n  border-color: #A61B34;\n}\n\n/* Calendario nativo alineado al tema oscuro */\n.bad-filter input.bad-date-input {\n  color-scheme: dark;\n  min-height: 38px;\n}\n\n.bad-filter input.bad-date-input::-webkit-calendar-picker-indicator {\n  cursor: pointer;\n  opacity: 0.75;\n  filter: invert(0.85);\n}\n\n.bad-filter input.bad-date-input::-webkit-calendar-picker-indicator:hover {\n  opacity: 1;\n}\n\n.bad-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 16px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: background 0.15s, border-color 0.15s, opacity 0.15s;\n}\n\n.bad-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.bad-btn-primary {\n  background-color: #A61B34;\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.bad-btn-primary:hover:not(:disabled) {\n  background-color: #8b1530;\n}\n\n.bad-btn-ghost {\n  background-color: #1a1a1a;\n  color: #e5e7eb;\n  border-color: #2a2a2a;\n}\n\n.bad-btn-ghost:hover:not(:disabled) {\n  background-color: #374151;\n  color: #ffffff;\n  border-color: #4b5563;\n}\n\n.bad-btn-sm {\n  padding: 6px 10px;\n  font-size: 0.8125rem;\n}\n\n.bad-spin {\n  animation: bad-spin 0.9s linear infinite;\n}\n\n@keyframes bad-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.bad-banner {\n  padding: 10px 14px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  font-size: 0.875rem;\n}\n\n.bad-banner-error {\n  background: rgba(166, 27, 52, 0.15);\n  border: 1px solid rgba(220, 38, 38, 0.45);\n  color: #fecaca;\n}\n\n.bad-layout {\n  display: grid;\n  grid-template-columns: minmax(280px, 340px) 1fr;\n  gap: 20px;\n  align-items: start;\n}\n\n@media (max-width: 1100px) {\n  .bad-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.bad-aside {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.bad-main {\n  min-width: 0;\n}\n\n.bad-card {\n  background-color: #1a1a1a;\n  border: 1px solid #2a2a2a;\n  border-radius: 10px;\n  padding: 16px 18px;\n}\n\n.bad-card-fill {\n  display: flex;\n  flex-direction: column;\n  min-height: 420px;\n}\n\n.bad-card h2 {\n  margin: 0 0 6px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.bad-hint {\n  margin: 0 0 12px;\n  font-size: 0.75rem;\n  color: #9ca3af;\n  line-height: 1.4;\n}\n\n.bad-card-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.bad-card-head h2 {\n  margin: 0;\n}\n\n.bad-meta {\n  font-size: 0.8125rem;\n  color: #9ca3af;\n}\n\n.bad-table-wrap {\n  border-radius: 8px;\n  border: 1px solid #2a2a2a;\n  overflow: hidden;\n}\n\n.bad-table-scroll {\n  flex: 1;\n  overflow: auto;\n  max-height: min(58vh, 640px);\n  scrollbar-width: thin;\n  scrollbar-color: #4b5563 #111111;\n}\n\n.bad-table-scroll::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.bad-table-scroll::-webkit-scrollbar-track {\n  background: #111111;\n  border-radius: 4px;\n}\n\n.bad-table-scroll::-webkit-scrollbar-thumb {\n  background: #4b5563;\n  border-radius: 4px;\n}\n\n.bad-table-scroll::-webkit-scrollbar-thumb:hover {\n  background: #6b7280;\n}\n\n.bad-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8125rem;\n}\n\n.bad-table thead {\n  background-color: #111111;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.bad-table th {\n  color: #d1d5db;\n  font-weight: 600;\n}\n\n.bad-table th,\n.bad-table td {\n  padding: 10px 12px;\n  text-align: left;\n  border-bottom: 1px solid #2a2a2a;\n}\n\n.bad-table-dense th,\n.bad-table-dense td {\n  padding: 8px 10px;\n}\n\n.bad-table tbody tr:hover {\n  background-color: rgba(55, 65, 81, 0.35);\n}\n\n.bad-row-selected {\n  background-color: rgba(166, 27, 52, 0.22) !important;\n  box-shadow: inset 3px 0 0 #A61B34;\n}\n\n.bad-num {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.bad-empty {\n  text-align: center;\n  color: #9ca3af;\n  padding: 20px 12px !important;\n}\n\n.bad-status-cell {\n  vertical-align: middle;\n  text-align: center;\n}\n\n.bad-table thead th.bad-status-th {\n  text-align: center;\n}\n\n.bad-table thead th.bad-actions-th {\n  text-align: center;\n}\n\n.bad-status-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px 12px;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  border: 1px solid transparent;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n/* Pendiente: resalta en rojo (misma familia que #A61B34) */\n.bad-status-chip--pending {\n  background: rgba(166, 27, 52, 0.35);\n  color: #fecaca;\n  border-color: rgba(220, 38, 38, 0.65);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);\n}\n\n.bad-status-chip--done {\n  background: rgba(22, 163, 74, 0.22);\n  color: #86efac;\n  border-color: rgba(34, 197, 94, 0.55);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);\n}\n\n.bad-actions-col {\n  width: 1%;\n  vertical-align: middle;\n  text-align: center;\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n}\n\n.bad-action-btns {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 6px;\n  min-width: 7.5rem;\n  max-width: 10rem;\n  margin: 0 auto;\n}\n\n.bad-action-btn {\n  width: 100%;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.bad-actions-empty {\n  display: block;\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\n.bad-comment-cell {\n  max-width: 160px;\n  color: #9ca3af;\n  font-size: 0.78rem;\n  vertical-align: middle;\n}\n\n.bad-comment-cell--interactive {\n  cursor: pointer;\n}\n\n.bad-comment-cell--interactive:hover {\n  color: #e5e7eb;\n  background-color: rgba(55, 65, 81, 0.25);\n}\n\n.bad-comment-empty {\n  color: #6b7280;\n}\n\n.bad-comment-preview {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: break-word;\n}\n\n/* Modal solo lectura: mensaje y comentario de gestión completos */\n.bad-detail-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 10050;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  backdrop-filter: blur(2px);\n  box-sizing: border-box;\n}\n\n.bad-detail-dialog {\n  width: 100%;\n  max-width: min(720px, calc(100vw - 32px));\n  max-height: calc(100vh - 48px);\n  display: flex;\n  flex-direction: column;\n  background: #1a1a1a;\n  border: 1px solid #2a2a2a;\n  border-radius: 12px;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);\n  font-family: inherit;\n  color: #f3f4f6;\n}\n\n.bad-detail-header {\n  padding: 18px 20px 14px;\n  border-bottom: 1px solid #2a2a2a;\n  flex-shrink: 0;\n}\n\n.bad-detail-title {\n  margin: 0 0 8px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.bad-detail-sub {\n  margin: 0;\n  font-size: 0.8125rem;\n  color: #9ca3af;\n  line-height: 1.45;\n}\n\n.bad-detail-body {\n  padding: 16px 20px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.bad-detail-grid {\n  display: grid;\n  grid-template-columns: 7.5rem 1fr;\n  gap: 8px 14px;\n  align-items: start;\n  margin-bottom: 16px;\n}\n\n.bad-detail-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #9ca3af;\n}\n\n.bad-detail-label--block {\n  display: block;\n  margin-bottom: 6px;\n}\n\n.bad-detail-value {\n  font-size: 0.875rem;\n  color: #e5e7eb;\n  word-break: break-word;\n}\n\n.bad-detail-block {\n  margin-bottom: 16px;\n}\n\n.bad-detail-block:last-child {\n  margin-bottom: 0;\n}\n\n.bad-detail-block--comment-first {\n  margin-bottom: 20px;\n}\n\n.bad-detail-char-count {\n  display: block;\n  margin: 0 0 8px;\n  font-size: 0.7rem;\n  color: #6b7280;\n  font-variant-numeric: tabular-nums;\n}\n\n.bad-detail-pre {\n  margin: 0;\n  padding: 12px 14px;\n  border-radius: 8px;\n  background: #0a0a0a;\n  border: 1px solid #2a2a2a;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n  max-height: min(200px, 32vh);\n  overflow-y: auto;\n  color: #d1d5db;\n}\n\n/* Comentario de gestión: sin tope de altura; el scroll es el del panel .bad-detail-body (un solo scroll, texto completo). */\n.bad-detail-pre--comment {\n  max-height: none;\n  min-height: 6rem;\n  overflow: visible;\n  font-size: 0.875rem;\n  line-height: 1.55;\n  padding: 14px 16px;\n  border-color: rgba(34, 197, 94, 0.35);\n}\n\n.bad-detail-pending-note {\n  margin: 0;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: #9ca3af;\n}\n\n.bad-detail-footer {\n  padding: 14px 20px 18px;\n  border-top: 1px solid #2a2a2a;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.bad-pagination {\n  display: flex;\n  gap: 10px;\n  margin-top: 14px;\n  padding-top: 4px;\n}\n\n/* ─── Export modal ─────────────────────────────────────────── */\n\n.bad-export-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 10050;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  backdrop-filter: blur(2px);\n  box-sizing: border-box;\n}\n\n.bad-export-dialog {\n  width: 100%;\n  max-width: 420px;\n  background: #1a1a1a;\n  border: 1px solid #2a2a2a;\n  border-radius: 12px;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);\n  color: #f3f4f6;\n  display: flex;\n  flex-direction: column;\n}\n\n.bad-export-header {\n  padding: 20px 22px 14px;\n  border-bottom: 1px solid #2a2a2a;\n}\n\n.bad-export-header-icon {\n  color: #A61B34;\n  margin-bottom: 8px;\n}\n\n.bad-export-title {\n  margin: 0 0 8px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.bad-export-sub {\n  margin: 0;\n  font-size: 0.8125rem;\n  color: #9ca3af;\n  line-height: 1.45;\n}\n\n.bad-export-options {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n  padding: 20px 22px;\n}\n\n.bad-export-option {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 20px 12px;\n  border-radius: 10px;\n  border: 1px solid #2a2a2a;\n  background: #111111;\n  color: #e5e7eb;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s, transform 0.1s;\n}\n\n.bad-export-option:hover:not(:disabled) {\n  border-color: #A61B34;\n  background: rgba(166, 27, 52, 0.1);\n  transform: translateY(-1px);\n}\n\n.bad-export-option:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.bad-export-option:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.bad-export-option-icon {\n  opacity: 0.9;\n}\n\n.bad-export-option-icon--pdf {\n  color: #ef4444;\n}\n\n.bad-export-option-icon--excel {\n  color: #22c55e;\n}\n\n.bad-export-option-label {\n  font-size: 0.95rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.bad-export-option-desc {\n  font-size: 0.72rem;\n  color: #9ca3af;\n  text-align: center;\n  line-height: 1.35;\n}\n\n.bad-export-loading {\n  text-align: center;\n  font-size: 0.8125rem;\n  color: #A61B34;\n  padding: 0 22px 8px;\n  animation: bad-pulse 1.2s ease-in-out infinite;\n}\n\n@keyframes bad-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n.bad-export-footer {\n  padding: 14px 22px 18px;\n  border-top: 1px solid #2a2a2a;\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* Bloque de reproducción de audio (perifoneo / alerta personalizada) en el modal de detalle */\n.bad-detail-audio-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.bad-detail-audio-hint {\n  color: #9ca3af;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
